var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"icon":"","href":_vm.readableUrl,"target":"_blank","x-large":"","title":_vm.label}},[_c('v-icon',[_vm._v(_vm._s(_vm.icon))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }